import { DashboardShell } from "@/components/layout/DashboardShell";
import { ROUTES } from "@/constants/routes";
import { RequireAuth } from "@/app/router/RequireAuth";
import DashboardPage from "@/pages/Dashboard";
import LoginPage from "@/pages/Login";
import MessagesPage from "@/pages/Messages";
import CallsPage from "@/pages/Calls";
import ContactsPage from "@/pages/Contacts";
import SettingsRoutePage from "@/pages/Settings";
import NotFoundPage from "@/pages/NotFound";
import UiKitPage from "@/pages/UiKit";
import type { RouteObject } from "react-router-dom";

export const routeConfig: RouteObject[] = [
  {
    path: ROUTES.login,
    element: <LoginPage />,
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <DashboardShell />,
        children: [
          { path: ROUTES.dashboard, element: <DashboardPage /> },
          { path: ROUTES.messages, element: <MessagesPage /> },
          { path: ROUTES.calls, element: <CallsPage /> },
          { path: ROUTES.contacts, element: <ContactsPage /> },
          { path: ROUTES.settings, element: <SettingsRoutePage /> },
          {
            path: ROUTES.uiKit.replace(/^\//, ""),
            element: <UiKitPage />,
          },
        ],
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
];
